import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptQuote, submitCounterOffer } from './api';
import { REQUESTS_KEY } from '../requests/hooks';

export function useAcceptQuote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (requestId: string) => acceptQuote(requestId),
    onSuccess: () => qc.invalidateQueries({ queryKey: REQUESTS_KEY }),
  });
}

export function useSubmitCounterOffer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ requestId, amount, note }: { requestId: string; amount: number; note?: string }) =>
      submitCounterOffer(requestId, { amount, note }),
    onSuccess: () => qc.invalidateQueries({ queryKey: REQUESTS_KEY }),
  });
}
